<template>
  <AdminInputCheckbox
    v-on="$listeners"
    v-bind="{ ...$attrs, ...$props }"
    :on="on"
    :size="size"
    :disabled="disabled"
    @click="toggle"
    class="admin-list-checkbox"
  />
</template>

<script>
import { Model } from '@vuex-orm/core'
import _get from 'lodash/get'
import AdminInputCheckbox from '@/components/AdminInputCheckbox'
export default {
  name: 'AdminCellCheckbox',
  components: { AdminInputCheckbox },
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
    fieldName: {
      type: String,
      require: true,
    },
    id: {
      type: [String, Number],
      require: true,
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  computed: {
    on() {
      return _get(this.Model.find(this.id), this.fieldName, false)
    },
  },
  methods: {
    async toggle() {
      if ('function' === typeof this.Model.updateModel) {
        const fields = { [this.fieldName]: !this.on }
        this.disabled = true
        try {
          await this.Model.updateModel(this.id, fields)
          this.error = false
        } catch (error) {
          this.error = true
        } finally {
          this.disabled = false
        }
      }
    }, // toggle
  },
  data() {
    return {
      error: false,
      disabled: false,
    }
  },
}
</script>

<style>
.admin-list-checkbox {
  cursor: pointer;
}
</style>
